import { render, staticRenderFns } from "./InputLoadMore.vue?vue&type=template&id=5fc288d8"
import script from "./InputLoadMore.vue?vue&type=script&lang=js"
export * from "./InputLoadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports